import { useStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { computed } from 'vue'

import type { Appearance } from '@/domains/admin-panel/composables/use-appearance/useAppearance.types'

import { APPEARANCES, DEFAULT_APPEARANCE } from '@/domains/admin-panel/composables/use-appearance/useAppearance.consts'

// Read before paint by the inline script in app.blade.php, so its values stay `system`, `light` and `dark`.
const APPEARANCE_KEY = 'twn:appearance'

const isAppearance = (value: unknown): value is Appearance => APPEARANCES.includes(value as Appearance)

/** The user's saved appearance, per browser (DEC-2026-060); every caller shares it. */
export const useAppearanceStore = defineStore('appearance', () => {
  const stored = useStorage<string>(APPEARANCE_KEY, DEFAULT_APPEARANCE)

  const appearance = computed<Appearance>(() => (isAppearance(stored.value) ? stored.value : DEFAULT_APPEARANCE))

  const setAppearance = (next: Appearance) => {
    stored.value = next
  }

  return { appearance, setAppearance }
})
